export const customScrollBarStyles = {
  mainContainer: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },
  contentContainer: {
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": { width: 0, height: 0 },
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  },
  thumbContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
    backgroundColor: "transparent",
    transition: "opacity 0.3s",
  },
  thumb: {
    position: "absolute",
    top: 0,
    right: 3.5,
    height: "30px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
};
